import { render } from "./FreebetRounds.vue?vue&type=template&id=22d38433"
import script from "./FreebetRounds.vue?vue&type=script&lang=js"
export * from "./FreebetRounds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__